import api from './api';

export interface SupervisorWorker {
  worker_id: string; worker_code: string; verified: string; band: string;
  eligibility: string; data_quality: string; is_on_shift: boolean; last_update: string | null; cleared: boolean;
  priority: boolean;
}
export interface Episode {
  id: string; worker_id: string; worker_code: string; kind: string; entered_at: string;
  band_recovered: boolean; recovered_at: string | null; status: string; acknowledged_at: string | null;
  acknowledged_by: string | null; closed_at: string | null; outcome: string | null;
  priority: boolean;
}
export interface LiveSupervisorSnapshot {
  synthetic_demo?: boolean;
  generated_at: string; sharing_phase: 'live';
  summary_scope?: 'VISIBLE_DIVISIONS';
  summary: { enrolled: number; on_shift: number; cleared: number; open_interventions: number; signal_unavailable: number };
  readiness: { band: string; hidden: boolean; count?: number }[]; displayed_readiness_total: number;
  workers: SupervisorWorker[]; interventions: Episode[]; outcomes: string[];
  divisions: ({ name: string; hidden: true; reason: 'SMALL_GROUP' | 'COMPLEMENTARY' } | { name: string; hidden: false; count: number })[];
}
export interface EvaluationSnapshot {
  generated_at: string; sharing_phase: 'shadow';
  workers: { worker_id: string; worker_code: string; status: 'EVALUATION PERIOD' }[];
}
export type SupervisorSnapshot = LiveSupervisorSnapshot | EvaluationSnapshot;
export interface WorkerDetail {
  worker: SupervisorWorker; work_period_start: string | null;
  segments: { band: string; entered_at: string; ended_at: string }[];
}
export const supervisorApi = {
  snapshot: async (): Promise<SupervisorSnapshot> => (await api.get('/fleet/dashboard')).data,
  detail: async (id: string): Promise<WorkerDetail> => (await api.get(`/fleet/workers/${id}`)).data,
  acknowledge: async (id: string) => api.post(`/fleet/interventions/${id}/acknowledge`),
  close: async (id: string, outcome: string) => api.post(`/fleet/interventions/${id}/close`, { outcome }),
};
